<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="SystemVal" @change="ReSetPage" clearable placeholder="审核系统">
                    <el-option v-for="i in SystemList" :key="i.id" :label="i.system_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="ViewVal" @change="ReSetPage" clearable placeholder="审核阶段">
                    <el-option label="初审/资料" value="1"></el-option>
                    <el-option label="复审/现场" value="2"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="StateVal" @change="ReSetPage" clearable placeholder="账号状态">
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="0"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="AuditVal" @change="ReSetPage" clearable placeholder="审核状态">
                    <el-option label="待审核" value="0"></el-option>
                    <el-option label="已通过" value="1"></el-option>
                    <el-option label="已驳回" value="2"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <el-upload action="none" :show-file-list="false" :http-request="UploadFlie">
                  <el-button v-throttle class="BgColor" size="small" type="info">批量上传</el-button>
                </el-upload>
                <!-- <el-button v-throttle class="BgColor" size="small" type="info" @click="DownUser">导出列表</el-button> -->
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增专家</el-button>
                <el-dropdown trigger="click" @command="SeleUser">
                    <el-button v-throttle size="small" type="primary" icon="el-icon-more"></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="DownMol">下载模板</el-dropdown-item>
                        <el-dropdown-item command="DownList">导出列表</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table"  @selection-change="SeleChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="姓名" min-width="80" />
            <el-table-column prop="username" label="账号" min-width="100" />
            <el-table-column prop="work_unit" label="工作单位" min-width="120" />
            <el-table-column prop="position" label="职务" min-width="80" />
            <el-table-column prop="title" label="职称" min-width="80" />
            <el-table-column prop="phone" label="电话" min-width="100" />
            <el-table-column prop="email" label="邮箱" min-width="150" />
            <el-table-column prop="jianli_url" label="简历" min-width="80" >
                <template slot-scope="scope">
                    <el-link type="primary" v-if="scope.row.jianli_url" @click="LockUrl(scope.row.jianli_url)">查看</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="systems" label="可操作项目" min-width="250" align="center">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <el-tag v-for="item in scope.row.systems" :key="item.id" type="success">
                            {{item.system_sub_name || item.system_name}}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="systems" label="可审核类型" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="BtnHead">
                        <el-tag v-if="scope.row.is_online_review" type="success">初审/资料</el-tag>
                        <el-tag v-if="scope.row.is_final_review" type="success">复审/现场</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="关闭/开启" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.zj_status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0" @change="ToggleState(scope.row)"/>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="140" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="审核" placement="top-start">
                        <i class="NavIcon el-icon-s-check" @click="ToggleAudit(scope.row)" v-if="scope.row.audit_status==0"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="重置密码" placement="top-start">
                        <i class="NavIcon el-icon-refresh-right" @click="ResetPass(scope.row.id)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">                        
                        <i class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>                    
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">
                          <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page"
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增专家':'修改专家'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">操作系统：</div>
                <!-- <el-cascader class="Wid" size="medium" v-model="NewData.system_sub_id" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader> -->
                <el-select class="Wid" size="medium" v-model="NewData.system_ids" placeholder="可操作系统" multiple>
                    <el-option v-for="item in SystemList" :key="item.id" :label="item.system_name"
                        :value="item.id"></el-option>
                </el-select>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">账号：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入账号" v-model="NewData.username"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">专业领域：</div>
                    <el-select class="Wid" size="medium" v-model="NewData.field_ids" placeholder="请选择专业领域">
                        <el-option v-for="item in LingYuList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <!-- <el-input class="Wid" size="medium" placeholder="请输入专业领域" v-model="NewData.expertise"></el-input> -->
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">手机号：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入手机号" v-model="NewData.phone"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">邮箱：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入邮箱" v-model="NewData.email"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">姓名：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入姓名" v-model="NewData.name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">工作单位：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入工作单位" v-model="NewData.work_unit"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">职称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入职称" v-model="NewData.title"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">职务：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入职务" v-model="NewData.position"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">简历：</div>
                    <el-upload v-if="!NewData.jianli_url" action="none" :show-file-list="false" :http-request="(res) => UploadJianLi(res)">
                        <el-button v-throttle class="BgColor" size="small" type="info">上传</el-button>
                        <span> 文件上传限制100M以内</span>
                    </el-upload>
                    <div v-else>
                        <span>文件</span>
                        <el-tooltip effect="dark" content="查看简历" placement="top-start">
                            <i class="NavIcon el-icon-view" @click="LockUrl(NewData.jianli_url)"></i>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="删除文件" placement="top-start">
                            <i class="NavIcon el-icon-delete" @click="NewData.jianli_url = ''"></i>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">初审/资料：</div>
                    <el-switch class="Wid" v-model="NewData.is_online_review" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">终审/现场：</div>
                    <el-switch class="Wid" v-model="NewData.is_final_review" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="Line"></div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">账号：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入账号" v-model="NewData.bank_card_number"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">户名：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入户名" v-model="NewData.bank_user_name"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">开户行：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入开户行" v-model="NewData.bank_name"></el-input>
                </div>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="账号审核" :visible.sync="AuditData.AuditBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">是否通过：</div>
                <el-radio-group v-model="AuditData.AuditVal">
                    <el-radio label="1">通过</el-radio>
                    <el-radio label="2">不通过</el-radio>
                </el-radio-group>
            </div>
            <div class="DigItem" v-if="AuditData.AuditVa==2">
                <div class="DigItemTit">驳回原因：</div>
                <el-input class="Wid" type="textarea" :rows="2" placeholder="请输入内容" v-model="AuditData.AuditRemark"> </el-input>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(AuditData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="AuditSuc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "UserTable",
        data() {
            return {
                SearchVal:"",
                SystemVal:"",
                AuditVal:"",
                StateVal:"",
                ViewVal:"",
                Data: [],
                SeleId:[],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                SystemList: '',
                LingYuList:'',
                NewData:{
                    id:'',
                    NewBlon:false,
                    username:"",
                    name:"",
                    phone:"",
                    email:"",
                    status:0,
                    bank_card_number:"",
                    bank_name:"",
                    bank_user_name:"",
                    work_unit:"",
                    position:"",
                    title:"",
                    field_ids:"",
                    jianli_url:"",
                    is_online_review:0,
                    is_final_review:0,
                    system_ids:"",
                },
                AuditData:{
                    id:"",
                    AuditBlon:false,
                    AuditVal:"1",
                    AuditRemark:"",
                }
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("SystemMenu"));
            this.GetData();
            this.GetLingYuList();
        },
        methods: {
            GetData(){
                this.$get('/admin/expert/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    audit_status:this.AuditVal,
                    status:this.StateVal,
                    system_id:this.SystemVal,
                    is_review:this.ViewVal,
                }).then(res=>{
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetLingYuList(){
                this.$get('/admin/expert_field/index').then(res=>{
                    if(res){
                        this.LingYuList = res.data;
                    }
                })
            },
            SeleUser(type){
                if(type == "DownMol"){this.DownMol()};
                if(type == "DownList"){this.DownUser()};
            },
            ToggleAudit(row){
                this.AuditData.id = row.id;
                this.AuditData.AuditBlon = true;
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.username = row.username;
                    this.NewData.name = row.name;
                    this.NewData.phone = row.phone;
                    this.NewData.email = row.email;
                    this.NewData.bank_card_number = row.bank_card_number;
                    this.NewData.bank_name = row.bank_name;
                    this.NewData.bank_user_name = row.bank_user_name;
                    this.NewData.work_unit = row.work_unit;
                    this.NewData.position = row.position;
                    this.NewData.title = row.title;
                    this.NewData.status = row.status;
                    this.NewData.field_ids = row.field_ids;
                    this.NewData.jianli_url = row.jianli_url;
                    this.NewData.is_online_review = row.is_online_review;
                    this.NewData.is_final_review = row.is_final_review;
                    this.NewData.system_ids = row.systems.map(item=>item.id);
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            SucData(){
                var url = "/admin/expert/update"
                if(this.Type=='Add'){
                    url = '/admin/expert/save';
                }
                this.$post(url,this.NewData).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        if(this.Type!='Add'){
                            this.GetData();
                        }else{
                            this.ReSetPage();
                        }
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            ToggleState(row){
                this.$post('/admin/expert/changeStatus',{
                    ids:[row.id],
                    zj_status:row.zj_status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            ResetPass(id){
               this.$confirm("此操作将重置密码, 是否继续?", "提示", {
                   type: "warning"
               }).then(() => {
                   this.$post('/admin/expert/resetPassword',{
                       id:id,
                   }).then(res=>{
                       if(res){
                           this.$message.success(res.msg);
                           this.GetData();
                       }
                   })
               }) 
            },
            SeleChange(val){
                this.SeleId = val.map(item => item.id);
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除申请人, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/expert/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success(res.msg);
                            this.GetData();
                        }
                    })
                })
            },
            AuditSuc(){
                this.$post('/admin/expert/audit',{
                    id:this.AuditData.id,
                    audit_status:this.AuditData.AuditVal,
                    reject_reason:this.AuditData.AuditRemark,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.AuditData)
                    }
                })
            },
            UploadFlie(res){
                var file = res.file;
                if (this.$Tools.ChangeExcel(file)) {
                    this.$message.error('只能上传Excel文件格式 (.xls, .xlsx, .xlsm, .xlsb)');
                    return false;
                }
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$post("/admin/expert/import",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.$message.success(res.msg);
                        this.GetData();
                    })
                } catch (error) {
                    loading.close();
                }
            },
            UploadJianLi(row){
                var file = row.file;
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                const MAX_SIZE = 100 * 1024 * 1024;
                const fileSize = file.size;
                if (fileSize > MAX_SIZE) {
                    this.$message.error(`文件大小超出限制！最大支持100M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                    return;
                }
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$post("/common/upload/image",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.NewData.jianli_url = res.data.url;
                    })
                } catch (error) {
                    loading.close();
                }
            },
            DownUser(){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/expert/export').then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            DownMol(){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/expert/download').then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
                // window.open(this.$Tools.ServeUrl()+'/common/download/template/expert.xlsx')
            },
            LockUrl(url){
                window.open(this.$Tools.ServeUrl()+url)
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
